import makeStyles from '@mui/styles/makeStyles';

export const SBWIDTH = 300;

const useStyles = makeStyles((theme) => ({
  pad: {
    padding: theme.spacing(2),
  },
  system: {
    pageBreakBefore: 'always',
    clear: 'both',
  },
  header: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
  },
  headerChild: {
    display: 'flex',
    alignItems: 'center',
    margin: 0,
    overflow: 'hidden',
  },
  headerChildName: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    overflowX: 'auto',
  },
  headerChildScore: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
    '@media print': {
      display: 'block',
    },
    width: 48,
  },
  headerCriteria: {
    lineHeight: 0,
    position: 'absolute',
    fontSize: '12px',
    bottom: theme.spacing(1),
    color: theme.colors.grey,
    fontWeight: 'normal',
  },
  sidebarHeaderChild: {
    marginRight: 15,
  },
  systemHeader: {
    top: 0,
    zIndex: 3,
    paddingLeft: theme.spacing(2),
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    marginTop: '1em',
    marginBottom: '1em',
  },
  checklistMenuHeader: {
    display: 'inline',
    fontSize: 'small',
  },
  wrapper: {
    display: 'flex',
    width: '100%',
    height: 'calc(100% - 176px)',
    '@media print': {
      position: 'relative',
      display: 'block',
      height: 'auto !important',
    },
  },
  wrapperCourse: {
    height: 'unset',
  },
  listItemWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    height: '100%',
    alignItems: 'center',
  },
  listItemWrapChild: {
    paddingLeft: theme.spacing(3),
  },
  expandIcon: {
    position: 'absolute',
    right: 5,
  },
  right: {
    position: 'relative',
    width: `calc(100% - ${SBWIDTH}px)`,
    maxWidth: theme.breakpoints.values['lg'],
    [theme.breakpoints.up('xl')]: {
      marginLeft: `calc(50% - ${theme.breakpoints.values['lg'] / 2}px - ${SBWIDTH}px)`,
    },
    right: 0,
    padding: theme.spacing(1),
    [theme.breakpoints.down('xl')]: {
      padding: 0,
      width: '100%',
    },
    '@media print': {
      width: '100%',
    },
  },
  rightCourse: {
    width: '100%',
    maxWidth: 'unset',
    [theme.breakpoints.up('xl')]: {
      marginLeft: 'unset',
    },
  },
  rightPrint: {
    width: '100%',
    [theme.breakpoints.up('xl')]: {
      marginLeft: 'unset',
    },
  },
  activeEditContainer: {},
  toggleSidebar: {
    // position: 'absolute',
    // right: 10,
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
    '@media print': {
      display: 'none',
    },
  },
  showImages: {
    color: theme.palette.secondary.main,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
    '@media print': {
      display: 'none',
    },
  },
  checklistActive: {
    fontWeight: 'bold',
    color: theme.palette.text.primary,
    borderTop: `1px solid ${theme.palette.action.disabledBackground}`,
    borderBottom: `1px solid ${theme.palette.action.disabledBackground}`,
  },
  checklistInactive: {
    backgroundColor: theme.palette.action.disabledBackground,
    color: theme.palette.text.disabled,
  },
  systemActive: {
    fontWeight: 'bold',
    color: theme.palette.text.primary,
  },
  systemInactive: {
    backgroundColor: theme.palette.action.disabledBackground,
    color: theme.palette.text.disabled,
  },
  grow: {
    flexGrow: 1,
  },
  show: {
    display: 'block',
  },
  hide: {
    display: 'none',
  },
  leftSidebar: {
    width: SBWIDTH,
    position: 'sticky',
    alignSelf: 'flex-start',
    top: 0,
    overflowY: 'auto',
    height: '100%',
    maxHeight: '100vh',
  },
  leftSidebarMobile: {
    '& .MuiDrawer-paper': {
      width: '80%',
    },
  },
  drawerPaper: {
    width: SBWIDTH,
    top: 177,
    bottom: 0,
    height: 'auto',

    '& .MuiList-padding': {
      padding: 0,
    },
  },
  overallScore: {
    textAlign: 'center',
    fontWeight: 'bold',
    justifyContent: 'center',
  },
}));

export const filterStyles = makeStyles((theme) => ({
  container: {
    top: 0,
    zIndex: 3,
    pointerEvents: 'auto',

    '@media print': {
      display: 'none',
    },
  },
  wrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    padding: `${theme.spacing(1.5)} 0 0`,
    overflowX: 'auto',
  },
  searchContainer: {
    marginBottom: 'unset',
    width: 240,
    minWidth: 200,
  },
  switchContainer: {
    padding: theme.spacing(1),
  },
  switchFlex: {
    display: 'flex',
  },
  buttonMargin: {
    paddingLeft: theme.spacing(2.5),
    marginRight: theme.spacing(1.5),
    color: 'grey',
  },
  center: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  select: {
    borderRadius: 4,
    marginRight: theme.spacing(1),
    '& .MuiFilledInput-input': {
      padding: '5px 12px 6px',
      paddingRight: 32,
    },
  },
  selectSelected: {
    backgroundColor: `${theme.palette.primary.main} !important`,
    color: `${theme.palette.common.white} !important`,
  },
  buttonIcon: {
    marginLeft: theme.spacing(1),
  },
  switchText: {
    textWrap: 'nowrap',
  },
}));

export const multiStyles = makeStyles((theme) => ({
  scorecardTitle: {
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: theme.spacing(1),
  },
}));

export default useStyles;
